module.exports = __webpack_public_path__ + "fonts/Roboto-Light.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Light.ttf
// module id = 3460
// module chunks = 0